export default __webpack_public_path__ + "static/media/querelle_perspective.561a3464.jpg";